<template>
    <span><textarea class="valueinput" wrap="soft" rows="5" style="width: 20em;" v-model="item.value"
                    :placeholder="$t('lang.main.f_rules_new_str')"></textarea></span>
</template>

<script>
import {Listeners} from "../../../constants/listeners";

export default {
    name: "Enum",
    props: {
        item: {
            type: Object,
            required: true

        }
    },
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        }
    },
}
</script>
